import { axios } from '~/common/utils/request'
const commonPath = 'rest/erp/logistics/v3/'

// 库位统计租户列表
export const getBusinessAccount = params => axios({
  url: `${commonPath}lot/business/account/all`,
  method: 'post',
  data: params
})

// 存货项统计租户列表
export const getShopList = params => axios({
  url: `${commonPath}stock/business/account/all`,
  method: 'post',
  data: params
})

// 联系人列表
export const getReceiverContact = params => axios({
  url: `${commonPath}picking/receiver_contact/list`,
  method: 'post',
  data: params
})

// 租户下交易员
export const getShopMemberList = params => axios({
  url: `${commonPath}rent/shop_member/all`,
  method: 'post',
  data: params
})

// 调拨单创建
export const movingCreate = params => axios({
  url: `${commonPath}moving`,
  method: 'post',
  data: params
})

// 调拨单列表
export const movingList = params => axios({
  url: `${commonPath}moving/order/list`,
  method: 'post',
  data: params
})

// 调拨人/分拣人
 export const getMovingMember = () => axios({
  url: `${commonPath}moving/member/all`,
  method: 'get'
})

// 调拨单详情
export const getMovingOrderDetail = id => axios({
  url: `${commonPath}moving/order/detail/${id}`,
  method: 'get'
})

// 调拨单-调拨项列表
export const movingOrderLineList = params => axios({
  url: `${commonPath}moving/order/line/list`,
  method: 'post',
  data: params
})

// 调拨单编辑
export const editMovingOrder = params => axios({
  url: `${commonPath}moving/order`,
  method: 'put',
  data: params
})

// 调拨项打印标签
export const movingLinePrint = id => axios({
  url: `${commonPath}moving/line/print/${id}`,
  method: 'get'
})

// 调拨项列表
export const movingLineList = params => axios({
  url: `${commonPath}moving/line/list`,
  method: 'post',
  data: params
})

// 调拨项详情
export const getMovingLineDetail = id => axios({
  url: `${commonPath}moving/line/detail/${id}`,
  method: 'get'
})

// 调拨项编辑
export const editMovingLineOrder = params => axios({
  url: `${commonPath}moving/line`,
  method: 'put',
  data: params
})

// 调拨单、调拨项联系人
export const getMovingContacts = params => axios({
  url: `${commonPath}moving/contacts`,
  method: 'post',
  data: params
})

// 调拨项关单项
export const getTariffDetail = params => axios({
  url: `${commonPath}moving/line/tariff/detail`,
  method: 'post',
  data: params
})

// 盘点单创建
export const stockCheckCreate = params => axios({
  url: `${commonPath}stock_check`,
  method: 'post',
  data: params
})

// 盘点单列表
export const stockCheckList = params => axios({
  url: `${commonPath}stock_check/query`,
  method: 'post',
  data: params
})

// 盘点分拣人
export const getStockMember = params => axios({
  url: `${commonPath}stock_check/check_by/list`,
  method: 'post',
  data: params
})

// 盘点单详情
export const getStockCheckDetail = id => axios({
  url: `${commonPath}stock_check/detail/${id}`,
  method: 'get'
})

// 盘点项打印标签
export const stockCheckLinePrint = id => axios({
  url: `${commonPath}stock_check/line/print/${id}`,
  method: 'get'
})

// 盘点项列表
export const stockCheckLineList = params => axios({
  url: `${commonPath}stock_check_line/query`,
  method: 'post',
  data: params
})

// 盘点提交
export const submitStockCheck = id => axios({
  url: `${commonPath}stock_check/submit/${id}`,
  method: 'get'
})

// 盘点撤回
export const cancelStockCheck = id => axios({
  url: `${commonPath}stock_check/cancel/${id}`,
  method: 'get'
})

// 盘点审批通过
export const approveStockCheck = params => axios({
  url: `${commonPath}stock_check/passed`,
  method: 'post',
  data: params
})

// 盘点审批退回
export const returnStockCheck = params => axios({
  url: `${commonPath}stock_check/reject`,
  method: 'post',
  data: params
})

// 盘点项详情
export const getStockCheckLineDetail = id => axios({
  url: `${commonPath}stock_check_line/detail/${id}`,
  method: 'get'
})

// 盘点项编辑
export const editStockCheck = params => axios({
  url: `${commonPath}stock_check_line/update`,
  method: 'post',
  data: params
})

// 盘点项批量确认
export const confirmStockCheck = params => axios({
  url: `${commonPath}stock_check_line/confirm`,
  method: 'post',
  data: params
})
